// Simple content for demo
module.exports = {
  id: 'example-input-id-1',
  label: 'Label',
  width: 'm',
};
